import { Autocomplete, Checkbox, FormControlLabel, FormGroup, TextField, Typography } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useEffect, useState } from 'react';
import { FaFileExcel } from 'react-icons/fa';
import { FaFilePdf } from 'react-icons/fa6';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';

import { fetchAreasOrganizacionales, selectAllAreasOrganizacionales } from '../../redux/AreaOrganizacional/AreaOrganizacionalSlice';
import { fetchAllEmpleados, selectAllEmpleadosList } from '../../redux/Empleados/EmpleadosSlice';

import {
  fetchTiposPermisos,
  fetchTiposPermisosCategorias,
  selectAllTiposPermisos,
  selectAllTiposPermisosCategorias,
} from '../../redux/Permisos/PermisosSlice';

import moment from 'moment';
import swal from 'sweetalert';
import { fetchCambiarSuccess, fetchPermisosExportar, fetchPermisosExportarExcel, selectIsSuccess } from '../../redux/Reportes/ReportePermisosSlice';

const filtroDefaultValues = {
  areaId: [],
  permisoId: [],
  empleadoId: 0,
  fechaDesde: new Date(),
  fechaHasta: new Date(),
  estado: 1,
};

export const FiltroReportesPermisos = () => {
  // ? HOOK-DISPATCH
  const dispatch = useDispatch();

  // ? HOOK-SELECTOR
  const isSuccess = useSelector(selectIsSuccess);
  const tiposPermisos = useSelector(selectAllTiposPermisos);
  const listAreaOrganizacionales = useSelector(selectAllAreasOrganizacionales);
  const listEmpleados = useSelector(selectAllEmpleadosList);
  const listPermisosCategorias = useSelector(selectAllTiposPermisosCategorias);

  // ? HOOK-STATE
  const [filtroState, setFiltroState] = useState(filtroDefaultValues);
  const [checked, setChecked] = useState(true);

  // ? STATE DE LISTAS.
  const [listaEmpleadosState, setListaEmpleadosState] = useState([]);

  const updateSuccess = () => dispatch(fetchCambiarSuccess());

  // ? USE-EFFECT
  useEffect(() => {
    dispatch(fetchAreasOrganizacionales());
    dispatch(fetchAllEmpleados());
    dispatch(fetchTiposPermisos());
    dispatch(fetchTiposPermisosCategorias());
  }, [dispatch]);

  useEffect(() => {
    const state = checked === true ? 1 : 0;
    setFiltroState({ ...filtroState, estado: state });
  }, [checked]);

  // * USE-EFFECT PARA EL SWEET-ALERT.
  useEffect(() => {
    if (isSuccess === 'success') {
      swal('Exitoso!', 'El reporte fue generado.', 'success');
      updateSuccess();
      setFiltroState(filtroDefaultValues);
    } else if (isSuccess === 'error') {
      swal('Error', 'Por favor, comunicarse con el departamento de Desarrollo e Implentación de Sistemas.', 'error');
      updateSuccess();
    }
  }, [isSuccess]);

  // ? HOOK-EFFECT QUE AÑADE UN NUEVO VALOR A LAS LISTAS CORRESPONDIENTES.
  useEffect(() => {
    setListaEmpleadosState([{ id: 0, nombreLabel: 'Seleccionar Empleado' }, ...listEmpleados]);
  }, [listAreaOrganizacionales, listEmpleados, listPermisosCategorias]);

  // * FUNCION PARA ACTUALIZAR CAMPOS
  const updateFilter = (name, value) => setFiltroState({ ...filtroState, [name]: value });

  // * FUNCION QUE GENERA EL ARCHIVO
  const onGenerateFile = (file = undefined) => {
    const filtro = {
      desde: moment(filtroState.fechaDesde).format('YYYY-MM-DD'),
      hasta: moment(filtroState.fechaHasta).format('YYYY-MM-DD'),
      areaId: filtroState.areaId,
      codigoEmpleado: filtroState.empleadoId,
      tipoPermiso: filtroState.permisoId,
      estado: filtroState.estado,
    };

    if (file === 'Excel') {
      dispatch(fetchPermisosExportarExcel(filtro));
    } else if (file === 'PDF') {
      dispatch(fetchPermisosExportar(filtro));
    }
  };

  return (
    <div className="card mb-2">
      <div className="card-body">
        <div className="row">
          <div className="col-3">
            <div className="form-group">
              <Typography fontSize="12px" fontWeight="bold">
                Fecha Desde
              </Typography>

              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="dd/MM/yyyy"
                  label=" "
                  mask="__/__/____"
                  value={filtroState.fechaDesde}
                  onChange={(e) => updateFilter('fechaDesde', e)}
                  renderInput={(params) => <TextField height={10} className="form-control" style={{ height: 10 }} {...params} />}
                />
              </LocalizationProvider>
            </div>
          </div>

          <div className="col-3">
            <div className="form-group">
              <Typography fontSize="12px" fontWeight="bold">
                Fecha Hasta
              </Typography>

              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  inputFormat="dd/MM/yyyy"
                  minDate={filtroState.fechaDesde}
                  label=" "
                  mask="__/__/____"
                  value={filtroState.fechaHasta}
                  onChange={(e) => updateFilter('fechaHasta', e)}
                  renderInput={(params) => <TextField height={10} className="form-control" style={{ height: 10 }} {...params} />}
                />
              </LocalizationProvider>
            </div>
          </div>

          <div className="col-6">
            <div className="form-group">
              <Typography fontSize="12px" fontWeight="bold">
                Áreas Organizacionales
              </Typography>
              <Autocomplete
                id="select-areas"
                value={listAreaOrganizacionales.filter((x) => filtroState.areaId.some((v) => x.id === v))}
                multiple
                options={listAreaOrganizacionales}
                getOptionLabel={(option) => option.nombre}
                filterSelectedOptions
                onChange={(event, newValue) =>
                  updateFilter(
                    'areaId',
                    newValue.map((x) => x.id)
                  )
                }
                isOptionEqualToValue={(option, val) => option.id === val.id} // clave para evitar duplicados
                renderInput={(params) => <TextField {...params} key={params.id} label=" " placeholder="Seleccionar Áreas" />}
                className="mb-2"
              />
            </div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="col-4">
            <div className="form-group">
              <Typography fontSize="12px" fontWeight="bold">
                Empleado
              </Typography>
              <Select
                id="select-empleado"
                classNamePrefix="select"
                isSearchable={true}
                placeholder="Seleccionar Empleado"
                options={listaEmpleadosState}
                getOptionLabel={(option) => option.nombreLabel}
                getOptionValue={(option) => option.id}
                onChange={(e) => updateFilter('empleadoId', e.id)}
                value={listaEmpleadosState.find((x) => x.id === filtroState.empleadoId)}
              />
            </div>
          </div>

          <div className="col-5">
            <div className="form-group">
              <Typography fontSize="12px" fontWeight="bold">
                Tipos de Permisos
              </Typography>
              <Autocomplete
                value={tiposPermisos.filter((x) => filtroState.permisoId.some((v) => x.id === v))}
                multiple
                id="tags-outlined"
                options={tiposPermisos}
                getOptionLabel={(option) => option.nombre}
                filterSelectedOptions
                onChange={(event, newValue) => {
                  updateFilter(
                    'permisoId',
                    newValue.map((x) => x.id)
                  );
                }}
                isOptionEqualToValue={(option, val) => option.id === val.id}
                renderInput={(params) => <TextField {...params} key={params.id} label=" " placeholder="Seleccionar Permisos" />}
                className="mb-2"
              />
            </div>
          </div>

          <div className="col-3">
            <div className="form-group">
              <FormGroup sx={{ mt: 2 }}>
                <FormControlLabel
                  control={<Checkbox id="checkbox-empleados-activos" checked={checked} onChange={() => setChecked(!checked)} />}
                  label="Sólo empleado activos"
                />
              </FormGroup>
            </div>
          </div>
        </div>

        <div className="row mt-3">
          <div className="form-group">
            <div className="d-flex justify-content-end">
              <button
                type="button"
                style={{ marginRight: 3 }}
                id="btn-generar-reporte"
                className="btn btn-danger"
                onClick={() => onGenerateFile('PDF')}
              >
                Generar PDF <FaFilePdf style={{ marginTop: -3 }} fontSize={20} />{' '}
              </button>
              <button type="button" id="btn-generar-reporte" className="btn btn-success" onClick={() => onGenerateFile('Excel')}>
                Generar EXCEL <FaFileExcel style={{ marginTop: -3 }} fontSize={20} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
